import VuexPersistence from 'vuex-persist';

const session = new VuexPersistence({
  storage: window.sessionStorage,
});

export { session };
